import React from 'react';
import { Text } from 'library/ui';
import { Tooltip } from '@mui/material';
import { InfoRounded } from '@mui/icons-material';

export default function CardInfo({
    title = '',
    content,
    infoText,
    bodyTextBold = true,
    titleTextBold = false,
}: {
    title?: string;
    content: string;
    infoText?: string;
    bodyTextBold?: boolean;
    titleTextBold?: boolean;
}) {
    return (
        <Text size="xs" weight={titleTextBold ? 'bold' : 'regular'}>
            {title}{' '}
            <Text size="sm" weight={bodyTextBold ? 'bold' : 'regular'}>
                {content}
                {infoText ? (
                    <Tooltip title={infoText}>
                        <InfoRounded fontSize="small" sx={{ marginTop: '-4px' }} />
                    </Tooltip>
                ) : (
                    ''
                )}
            </Text>
        </Text>
    );
}
